import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output
} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {declarationResourceType} from "../../configs/declaration-modal-config";
import {declarationFormFields} from "../../configs/declaration-form-fields";
import {CreateDeclarationParams, DeclarationData} from "../../types/declaration-modal.types";
import {defaultDeclarationData} from "../../configs/default-declaration-data";
import {DeclarationModalService} from "../../services/declaration-modal.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-declaration-form',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatButton
  ],
  templateUrl: './declaration-form.component.html',
  styleUrls: [
    '../../declaration-modal.component.scss',
    './declaration-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeclarationFormComponent {
  parentId = input<number>(0);
  declarationData = input<DeclarationData>(defaultDeclarationData);
  declarationFormGroup = input<FormGroup>(new FormGroup({}));
  isEditModeActive = input<boolean>(false);
  noFirstData = input<boolean>(false);
  updateDeclarationData = output<DeclarationData>();
  deleteDeclaration = output<void>();

  private declarationModalService: DeclarationModalService = inject(DeclarationModalService);

  public readonly declarationFormFields = declarationFormFields;

  public getFieldClass(): string {
    if (!this.declarationData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.declarationData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: declarationResourceType.path,
      recordId: this.declarationData().id,
      fieldName: key,
      value: this.declarationFormGroup().get(key)?.value
    };

    const data = await this.declarationModalService.updatedRecordField<DeclarationData>(params)
      .catch(() => this.declarationData());
    this.updateDeclarationData.emit(data);
  }

  public handelDelete(): void {
    this.deleteDeclaration.emit();
  }

  public async handelCreate(): Promise<void> {
    const createDeclarationParams: CreateDeclarationParams = {
      technicalParametersId: this.parentId(),
      ...this.declarationFormGroup().value
    };

    const data = await this.declarationModalService.createDeclaration(createDeclarationParams)
      .catch(() => defaultDeclarationData);
    this.updateDeclarationData.emit(data);
  }
}
